export default __webpack_public_path__ + "static/last_year_1-fbcb83e6da38b19fb9d2dc1b61cb1186.webp";